// Copyright (c) 2026 by Audere

import { State as AuthState } from "./authSlice";
import { apiSlice } from "../api/apiSlice";

interface OpenIdAuthData {
  email: string;
  name: string;
  picture: string | null;
  api_token: string;
  api_token_valid_until: string;
}

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    openIdAuthenticate: builder.query<AuthState, string>({
      query: (credential) => ({
        url: "/openid_authenticate",
        method: "POST",
        headers: [["X-Audere-Token-Authority", "accounts.google.com"]],
        body: JSON.stringify({ credential, webapp: "ficus-manager" }),
      }),
      keepUnusedDataFor: 0,
      transformResponse: (result: OpenIdAuthData, _meta, arg) => {
        return {
          email: result.email,
          name: result.name,
          picture: result.picture,
          credentials: arg,
          token: result.api_token,
          expires: result.api_token_valid_until,
        };
      },
    }),
  }),
});

export const { useLazyOpenIdAuthenticateQuery } = authApiSlice;
